import type { SVGProps } from "react";

export default function CrashErrorIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.42577 8.96767C6.85774 4.65572 8.07372 2.49976 9.99935 2.49976C11.9249 2.49976 13.1409 4.65572 15.5729 8.96767L15.8759 9.50501C17.8969 13.0882 18.9074 14.8798 17.9941 16.1898C17.0808 17.4998 14.8213 17.4998 10.3024 17.4998H9.69627C5.17732 17.4998 2.91782 17.4998 2.00457 16.1898C1.0913 14.8798 2.10177 13.0882 4.12272 9.50501L4.42577 8.96767Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M10 6.66699V10.8337"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M9.99902 12.9181C10.2281 12.9181 10.4139 13.1041 10.4141 13.3331C10.4141 13.5622 10.2282 13.7481 9.99902 13.7481C9.77003 13.748 9.58398 13.5621 9.58398 13.3331C9.58416 13.1042 9.77013 12.9182 9.99902 12.9181Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.836854"
      />
    </svg>
  );
}
